import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.css";

import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Card from "./components/Card";
import Login from "./components/Login";
import Statistics from "./components/Statistics";
import FullPageSections from "./components/FullPageSection";
import CustomizationSection from "./components/CustomizationSection";
import ContactUs from "./components/ContactUs";
import AboutUs from "./components/AboutUs";
import ProductListingPage from "./components/ProductListingPage";
import ContactUsCard from "./components/ContactUsCard";
import Categories from "./components/Categories";
import NotFound from "./components/404";
import CookieConsent from "./components/CookieConsent";
import Certificates from "./components/Certificates";
import DiamondViewer from "./components/DiamondViewer";
import AdminPanel from "./components/Adminpanel";
import Privacy from "./components/Privacy";
import CookiePolicy from "./components/CookiePolicy";
import ScrollToTop from "./components/ScrollToTop";
import RequireAuth from "./components/RequireAuth";
import ProductDetail from "./components/Productdetail";

import WhatsAppSticky from "./components/WhatsAppSticky"; // Import the WhatsAppSticky component
import StickyWidgets from "./components/StickyWidgets"
// Analytics Component
const trackPageView = (url) => {
  if (window.gtag) {
    window.gtag("config", "G-VYE2BDJS2E", { page_path: url });
  }
};

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

const Loader = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{ color: 'white', fontSize: '24px' }}>Loading...</div>
    </div>
  );
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    setTimeout(() => {
      setLoading(false);
    }, 2000); // Hide loader after 2 seconds
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1200,
      offset: 200,
      once: true,
    });
  }, []);

  return (
    <>
      {loading && <Loader />}
      <HelmetProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
            <StickyWidgets/>
            {/* <WhatsAppSticky /> WhatsApp Sticky Icon */}
            <Analytics />
            <Header />
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <Hero />
                    <Card />
                    <Categories />
                    <DiamondViewer />
                    <Statistics />
                    <Certificates />
                    <ContactUsCard />
                  </>
                }
              />
              <Route path="/customization" element={<CustomizationSection />} />
              <Route path="/whatwedo" element={<FullPageSections />} />
              <Route path="/contactus" element={<ContactUs />} />
              <Route path="/aboutus" element={<AboutUs />} />
              <Route path="/login" element={<Login />} />
              <Route path="/detail" element={<ProductDetail/> }/>
              <Route
                path="/admin"
                element={
                  <RequireAuth>
                    <AdminPanel />
                  </RequireAuth>
                }
              />
              <Route path="/products/:category" element={<ProductListingPage />} />
              <Route path="/:category/:id" element={<ProductDetail />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
            <CookieConsent />
          </div>
        </Router>
      </HelmetProvider>
    </>
  );
}

export default App;
